import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { DamageReport } from '@models/damage-report';
import { ContractsService } from '../../contracts.service';
import { DamageReportsService } from '../damage-reports.service';
import { switchMap } from 'rxjs';
import { Contract } from '@models/contract';

export const damageReportResolveFn: ResolveFn<DamageReport> = (route: ActivatedRouteSnapshot) => {
    const contractId = parseInt('' + route.params.contractId, 10);
    const damageId = parseInt('' + route.params.damageId, 10);
    const contractsService = inject(ContractsService);
    const damageReportsService = inject(DamageReportsService);

    if (!isNaN(contractId) && !isNaN(damageId)) {
        return contractsService
            .get(contractId)
            .pipe(switchMap((contract: Contract) => damageReportsService.get(contract, damageId)));
    }
    throw new Error('damageReportResolveFn: contractId of damageId invalid');
};
